// Skeleton placeholder rendered during the first page fetch. Layout matches
// the real MembersPanel (chip strip + 8 list rows) so the swap-in does not
// cause layout shift.

import { cn } from "@shared/lib";

export interface MembersSkeletonProps {
  loadingLabel: string;
  className?: string;
}

function pulse(className: string): string {
  return cn("animate-pulse rounded-md bg-muted", className);
}

export function MembersSkeleton({ loadingLabel, className }: MembersSkeletonProps) {
  return (
    <div
      className={cn("flex flex-col gap-4", className)}
      role="status"
      aria-live="polite"
      aria-label={loadingLabel}
    >
      {/* Chip strip — 6 stage chips. */}
      <div className="flex flex-wrap gap-2">
        <div className={pulse("h-9 w-20")} />
        <div className={pulse("h-9 w-20")} />
        <div className={pulse("h-9 w-24")} />
        <div className={pulse("h-9 w-20")} />
        <div className={pulse("h-9 w-24")} />
        <div className={pulse("h-9 w-20")} />
      </div>
      {/* 8 row placeholders — same 60px footprint as MemberRow. */}
      <ul className="flex flex-col gap-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <li key={i} className={pulse("h-[60px]")} />
        ))}
      </ul>
    </div>
  );
}
